export const updateState = (prevState, newValue, isAllSelected) => {
    if (isAllSelected) return newValue;
    return newValue.length > prevState.length ? newValue.filter(value => prevState.includes(value)) : newValue;
};

export const getChipsLabel = value => {
    if (!value) return '';
    const label = value?.map(item => item.label).join(', ');
    const countString = value?.length > 1 ? `(${value?.length})` : '';
    return `${countString} ${label}`;
};

export const createUpdatedChips = (filterChips, filter, options) => {
    let updatedChips = { ...filterChips };

    Object.keys(updatedChips).forEach(key => {
        switch (key) {
            case 'timeframe':
                updatedChips[key] = filter.timeframe;
                break;
            case 'ageBracket':
                updatedChips[key] = filter[key] ? options[key].filter(i => i.value === filter[key]) : [];
                break;
            case 'hideAnonimous':
            case 'onlyFeatured':
                updatedChips[key] = filter[key] || false;
                break;
            case 'locations':
            case 'companies':
                updatedChips[key] =
                    filter?.[key]?.length < options?.[key]?.length
                        ? options?.[key]?.filter(i => filter?.[key]?.some(c => c.id === i.id))
                        : [];
                break;
            case 'channels':
                updatedChips[key] =
                    filter?.channels?.length < options?.channels?.length
                        ? options?.channels
                              ?.filter(i => filter?.channels?.some(c => c === i.value))
                              .map(c => ({ label: c.name }))
                        : [];
                break;
            default:
                updatedChips[key] =
                    filter?.[key]?.length < options?.[key]?.length
                        ? options?.[key]?.filter(i => filter?.[key]?.includes(i.value))
                        : [];
                break;
        }
    });
    return updatedChips;
};

export const getThemesFilterOptions = (themes, companies, t) => {
    const themesSet = new Set();
    companies?.forEach(company => {
        const companyThemes = themes[company] || [];
        companyThemes.forEach(theme => themesSet.add(theme));
    });
    return Array.from(themesSet)
        .sort()
        .map(theme => ({ label: t ? t(`themes.${theme}`, theme) : theme, value: theme }));
};

export const getKeywordsFilterOptions = (keywords, companies) => {
    const keywordsMap = {};
    companies?.forEach(company => {
        const companyKw = keywords[company] || [];
        for (const kw of companyKw) {
            if (!keywordsMap[kw.keyword]) {
                keywordsMap[kw.keyword] = kw.reviewsCount;
            } else {
                keywordsMap[kw.keyword] = keywordsMap[kw.keyword] + kw.reviewsCount;
            }
        }
    });
    return Object.entries(keywordsMap)
        .map(([key, value]) => ({ label: `${key} (${value})`, value: key, sortableField: value }))
        .sort((a, b) => b.sortableField - a.sortableField)
        .slice(0, 100);
};

export const isChipActive = value => {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'boolean') return value;
    return !!value?.start;
};

export const hasActiveChips = chips => Object.values(chips).some(isChipActive);
